import { Breadcrumbs, Typography, Link, Stack, TablePagination } from "@mui/material";
import { Link as LinkTo } from "react-router";
import { ObrasTopHeader } from "../../components/obras_top_header";
import { ObrasTopBar } from "../../components/obras_top_bar";
import { useObraItensChecklistAreaCadastroViewModel } from "../../viewModels/obra_itens_checklist_area_cadastro_view_model";
import { Header } from "./components/header";
import { StatisticsPanel } from "./components/statistics_panel";
import { LegendComponent } from "../../../../../common/components/legend_component";
import { LegendTagIcon } from "../../../../../common/components/legend_tag_icon";
import { LegendTagItemComponent } from "../../../../../common/components/legend_tag_item_component";
import { CustomStyledDataGrid } from "../Obras_cadastroarea/components/custom_styled_data_grid";
import { useMemo } from "react";
import { GenerateObraItensChecklistAreaCadastroColumnDefs } from "./columns";
import { InspecaoObra } from "../../../domain/models/inspecao_obra";
import { InspecaoObraAprovacaoModal } from "./components/inspecao_obra_aprovacao_modal";
import { InspecaoObraModal } from "./components/inspecao_obra_modal";
import { InspecaoObraCopyModal } from "./components/inspecao_obra_copy_modal";
import { GRID_CHECKBOX_SELECTION_FIELD, GridPinnedColumnFields } from "@mui/x-data-grid-pro";
import { ObraChecklistServicoGraficoModal } from "./components/obra_checklist_servico_grafico_modal";
import { ObrasReportModals } from "../../components/obras_report_modals";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";

import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import AlertError from "../../../../../common/components/alert_error";
import BottomBar from "../../../../../common/components/bottom_bar";
import DeleteDialog from "../../../../../common/components/delete_dialog";

/**
 * ObraItensChecklistAreaCadastro
 */

export const ObraItensChecklistAreaCadastro = () => {
  const viewModel = useObraItensChecklistAreaCadastroViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateObraItensChecklistAreaCadastroColumnDefs({
      statusChecklistServico: viewModel.statusChecklistServico,
      obraChecklistServicoCampos: viewModel.obraChecklistServicoCampos,
      onActionEditar: viewModel.handleInspecaoObraOpenState,
      onActionDeletar: viewModel.handleInspecaoObraDeletar,
      onActionCopy: viewModel.handleInspecaoObraCopy,
      onActionReport: viewModel.handleChecklistAreaReport,
      onEnterInspecaoObra: viewModel.handleEnterInspecaoObra,
    });
  }, [
    viewModel.statusChecklistServico,
    viewModel.obraChecklistServicoCampos,
    viewModel.handleInspecaoObraOpenState,
    viewModel.handleInspecaoObraDeletar,
    viewModel.handleInspecaoObraCopy,
    viewModel.handleChecklistAreaReport,
    viewModel.handleEnterInspecaoObra,
  ]);

  const pinnedColumns = useMemo((): GridPinnedColumnFields => {
    return viewModel.inspecoesObra.length > 0 ?
      {
        left: [
          GRID_CHECKBOX_SELECTION_FIELD,
        ],
        right: [
          'idInspecaoObra',
        ],
      } : {
      };
  }, [
    viewModel.inspecoesObra,
  ]);

  return (
    <>
      {/**
        * ObrasTopBar
        */}

      <ObrasTopBar
        obrasReportState={viewModel.obrasReportState}
        state={viewModel.obrasTopHeaderState}
        selectedObra={viewModel.selectedObraHeaderInfo ?? null}
        leftBackSlotButton={
          <>
            <div className="w-[9rem]">
              <PrimaryButton
                buttonColor="secondary"
                onMouseDown={e => {
                  viewModel.handleObraChecklistServicoGraficoOpenState(true);
                  e.preventDefault();
                }}>
                Gráfico Resumo
              </PrimaryButton>
            </div>
            {
              (viewModel.statusChecklistServico === 0) &&
              <div className="w-[8rem]">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onMouseDown={e => {
                    viewModel.handleInspecaoObraOpenState(null, true);
                    e.preventDefault();
                  }}>
                  Novo Item
                </PrimaryButton>
              </div>
            }
          </>
        }
        onBack={viewModel.handleBack}>
      </ObrasTopBar>

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Obras
          </Link>
          <Link underline="hover" color="inherit" component={'span'}>
            <LinkTo to='/Obras_lista'>Lista de Obras</LinkTo>
          </Link>
          <Link underline="hover" color="inherit" component={'span'}>
            <LinkTo to={`/Obras_cadastroarea?id=${viewModel.idObra}`}>Checklist de Área</LinkTo>
          </Link>
          <Link underline="hover" color="inherit" component={'span'}>
            <LinkTo to={`/Obras_checklistarea?id=${viewModel.idObra}&idChecklistArea=${viewModel.idObraAreaChecklist}`}>Checklist de Serviço</LinkTo>
          </Link>
          <Typography className="text-primary-green">
            Itens do Checklist
          </Typography>
        </Breadcrumbs>

        {/**
          * ObrasTopHeader
          */}

        <ObrasTopHeader
          title="Itens do Checklist"
          selectedObra={viewModel.selectedObraHeaderInfo ?? null}
          additionalHeader={
            viewModel.obraChecklistServicoHeader && (
              <div className="flex flex-row gap-8">
                <div className="flex flex-row text-black dark:text-white items-center">
                  <span className="font-extrabold text-base mr-2">Área: </span>
                  <span className="mx-1 font-base text-base">{viewModel.obraChecklistServicoHeader.descricaoArea}</span>
                </div>
                <div className="flex flex-row text-black dark:text-white items-center">
                  <span className="font-extrabold text-base mr-2">Checklist: </span>
                  <span className="mx-1 font-base text-base">{viewModel.obraChecklistServicoHeader.descricaoServico}</span>
                </div>
                <div className="flex flex-row text-black dark:text-white items-center">
                  <span className="font-extrabold text-base mr-2">Revisão: </span>
                  <span className="mx-1 font-base text-base">{viewModel.obraChecklistServicoHeader.revisao}</span>
                </div>
              </div>
            )
          }
          onReload={viewModel.handleReload}
        />

        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload}
                />
              </div>
            ) : (
              <>
                {
                  viewModel.estatisticasChecklistServico &&
                  <StatisticsPanel
                    statusChecklistArea={viewModel.obraAreaChecklistHeader !== null ? viewModel.obraAreaChecklistHeader.status : null}
                    statusChecklistServico={viewModel.statusChecklistServico}
                    metaChecklistServico={viewModel.metaChecklistServico}
                    estatisticasChecklistServico={viewModel.estatisticasChecklistServico}
                    onChangeStatus={viewModel.handleChecklistServicoStatusChange}
                    onChangeMeta={viewModel.handleChecklistServicoMetaChange}
                    onBlurStatus={viewModel.handleSubmitMetaChecklistServico}
                  />
                }

                <Header
                  data={viewModel.filters.data}
                  localizacao={viewModel.filters.localizacao}
                  status={viewModel.filters.status}
                  onDataChange={viewModel.handleDataChange}
                  onLocalizacaoChange={viewModel.handleLocalizacaoChange}
                  onStatusChange={viewModel.handleStatusChange}
                  onClear={viewModel.handleClearFilters}
                />

                <Stack spacing={0}>
                  <div className="w-full flex flex-row justify-between items-end">
                    <div className="flex flex-col flex-wrap">
                      <LegendComponent>
                        <LegendTagItemComponent
                          icon={<LegendTagIcon title='VNI' bgColor="#facc15" />}
                          label='Verificação Não Iniciada' />

                        <LegendTagItemComponent
                          icon={<LegendTagIcon title='VI' bgColor="#3b82f6" />}
                          label='Verificação Iniciada' />

                        <LegendTagItemComponent
                          icon={<LegendTagIcon title='E' bgColor="#ef4444" />}
                          label='Encerrada' />

                        <LegendTagItemComponent
                          icon={<LegendTagIcon title='A' bgColor="#009c4e" />}
                          label='Aprovado' />

                      </LegendComponent>
                    </div>
                  </div>

                  <CustomStyledDataGrid
                    tableName="obra_itens_checklist_area_cadastro"
                    disableColumnMenu={false}
                    getRowId={(row: InspecaoObra) => row.idInspecaoObra}
                    getRowHeight={() => 'auto'}
                    columns={columnsDefinition}
                    loading={viewModel.loading}
                    rows={viewModel.inspecoesObra}
                    rowCount={viewModel.inspecoesObra.length}
                    checkboxSelection={true}
                    textSize="pequeno"
                    pinnedColumns={pinnedColumns}
                    disableRowSelectionOnClick={true}
                    rowSelectionModel={viewModel.rowSelectionModel}
                    isRowSelectable={x => x.row.status === 1/* Encerrada */}
                    onRowSelectionModelChange={viewModel.handleRowSelectionModelChange}
                    disableColumnSorting={false}
                    pageSizeOptions={[10, 25, 50, 100]}
                    paginationMode="server"
                    paginationModel={{
                      page: viewModel.pagination.page,
                      pageSize: viewModel.pagination.rowsPerPage,
                    }}
                  />

                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />

                </Stack>
              </>
            )
        }
      </div>

      {/**
        * BottomBar
        */}

      <BottomBar>
        <div className="w-full h-full items-center justify-between flex p-4 gap-4">
          <div>
          </div>

          <div className="flex flex-row gap-4">
            {
              (viewModel.statusChecklistServico === 0) &&
              <div className="w-[200px]">
                <PrimaryButton
                  buttonColor="secondary"
                  onClick={() => viewModel.handleInspecaoObraAprovacaoOpenState(true)}
                  startIcon={<DynamicIcon nameIcon="Check" size={25} className="text-[#009C4E]" />}>
                  Aprovar Selecionados
                </PrimaryButton>
              </div>
            }
          </div>
        </div>
      </BottomBar>

      {/**
        * Modals
        */}

      <InspecaoObraModal
        open={viewModel.inspecaoObraModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectecInspecaoObra={viewModel.selectedInspecaoObra}
        obraChecklistServicoCampos={viewModel.obraChecklistServicoCampos}
        onClose={() => viewModel.handleInspecaoObraOpenState(null, false)}
        onSubmit={viewModel.handleInspecaoObraSubmit}
      />

      <InspecaoObraAprovacaoModal
        open={viewModel.inspecaoObraAprovacaoModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        funcionarioInformation={viewModel.funcionarioInformation}
        onClose={() => viewModel.handleInspecaoObraAprovacaoOpenState(false)}
        onSubmit={viewModel.handleInspecaoObraAprovacaoSubmit}
      />

      <InspecaoObraCopyModal
        open={viewModel.inspecaoObraCopyModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        onClose={viewModel.handleInspecaoObraCopy}
        onSubmit={viewModel.handleInspecaoObraCopyConfirm}
      />

      <ObraChecklistServicoGraficoModal
        open={viewModel.obraChecklistServicoGraficoModal}
        loading={viewModel.loading}
        estatisticasChecklistServico={viewModel.estatisticasChecklistServico}
        onClose={() => viewModel.handleObraChecklistServicoGraficoOpenState(false)}
      />

      <DeleteDialog
        open={viewModel.inspecaoObraDeleteModal}
        saving={viewModel.saving}
        title='Você realmente deseja excluir este item?'
        onClose={() => viewModel.handleInspecaoObraDeletar(null, false)}
        onDelete={() => viewModel.handleInspecaoObraDeletarConfirm()}
      />
      {/**
        * Relatorios obras.
        */}

      <ObrasReportModals
        state={viewModel.obrasReportState}
      />

      <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      />

    </>
  );
}